module.exports = __webpack_public_path__ + "/img/Radial-Round-u6hbDL.svg";